import Swiper from 'swiper/bundle';

export default carouselHome => {
    // console.log('carouselHome');

    new Swiper(carouselHome.querySelector('.swiper-container'), {
        slidesPerView: 'auto',
        spaceBetween: 30,
        // Disable preloading of all images
        // preloadImages: false,
        // Enable lazy loading
        // lazy: true,
        // watchSlidesVisibility: true,
        // grabCursor: true,
        navigation: {
            nextEl: '.swiper-button.swiper-button-next',
            prevEl: '.swiper-button.swiper-button-prev',
        },
        breakpoints: {
            576: {
                // spaceBetween: 30,
            },
            768: {
                // spaceBetween: 30,
            },
            992: {
                // spaceBetween: 30,
            },
            1200: {
                // spaceBetween: 30,
            },
            1370: {
                // spaceBetween: 30,
                allowTouchMove: false,
            },
        },
    });
};
